import { CircularLoader } from '../CircularLoader';

interface VirtualListRowProps<T> {
  data: T[];
  index: number;
  renderRowComponent: (listItem: T) => JSX.Element;
}

export const VirtualListRow = <T extends unknown>({
  data,
  index,
  renderRowComponent,
}: VirtualListRowProps<T>) => {
  if (!data) {
    return null;
  }

  if (!data[index]) {
    return <CircularLoader size={20} />;
  }

  return renderRowComponent(data[index]);
};
